export default __webpack_public_path__ + "static/cruiselines-carnival-ship-3-d7d5d57050eb8a9342c2b182bb1b29d4.jpg";